import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Header, InlineLink } from 'modules/styled';
import { refreshTab } from 'modules/navigation/navigation.actions';

const Breadcrumbs = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const newPosts = useSelector((state) => state?.posts?.newPostsAvailable);
  const community = useSelector((state) => state.community);
  const view = useSelector((state) => state?.navigation?.discover);

  const communitySlug = view?.discover?.community || auth.community;
  if (!communitySlug) {
    return null;
  }
  const activeCommunity = community?.communities?.[communitySlug];
  const sort = view?.sort || 'relevant';

  const newPostsNumber = newPosts[auth.community];
  const refreshPostsEl = (
    <InlineLink to="#" onClick={() => dispatch(refreshTab('discover'))} hu={1}>
      <Header sx={{ ml: 1, color: 'blue', lh: 1, fontSize: 1 }}>See New Posts</Header>
    </InlineLink>
  );

  return (
    <Row>
      {activeCommunity ? (
        <InlineLink
          sx={{ lineHeight: 1 }}
          hu={1}
          c={'black'}
          to={encodeURI(`/${communitySlug}/${sort}`)}
        >
          <Header sx={{ color: 'black', lineHeight: 1, fontSize: 1, m: 0 }}>
            Community: {activeCommunity?.name}{' '}
          </Header>
        </InlineLink>
      ) : null}
      {view?.tag ? (
        <InlineLink
          sx={{ lineHeight: 1 }}
          lh={1}
          hu={1}
          to={encodeURI(`/${communitySlug}/${sort}/${view.tag}`)}
        >
          <Header sx={{ color: 'black', lineHeight: 1, fontSize: 1, m: 0 }}>
            &nbsp;→ #{view?.tag}
          </Header>
        </InlineLink>
      ) : null}

      {newPostsNumber ? refreshPostsEl : null}
    </Row>
  );
};

export default Breadcrumbs;
